import enCatalog from '../locale/en/messages'
import slCatalog from '../locale/sl/messages'

//  Merge languages into catalog

export default {
	en: enCatalog,
	sl: slCatalog
}
